import SelectManualService from '@/views/SelectManualService/index.vue'

const SelectManualServiceRouter = {
  path: '/select-manual-service',
  name: 'SelectManualService',
  component: SelectManualService,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default SelectManualServiceRouter
